export const BIG_MESURMENT_UNIT = {
    "1": "t/ha",
    "2": "st/acre",
};
export const SMALL_MESURMENT_UNIT = {
    "1": "kg/ha",
    "2": "pound/acre",
};

export const YIELD_MIN = {
    "1": 0,
    "2": 0,
};

export const YIELD_MAX = {
    "1": 99999,
    "2": 99999,
};

export const WATER_REGIMES_KEYS = [1, 2, 3, 4];

export const SOIL_TYPES_KEYS = [1, 2, 3, 4];

export const DEFAULT_WATER_REGIME = 2;

export const DEFAULT_SOIL_TYPE = 2;

export const DEFAULT_TEMPERATURE = {
    "1": 21,
    "2": 70,
};

export const TEMPERATURE_MIN = {
    "1": 9,
    "2": 30,
};

export const TEMPERATURE_MAX = {
    "1": 35,
    "2": 116,
};

export const TEMPERATURE_UNITS = {
    "1": "C",
    "2": "F",
};

export const MIN_HOT_TEMPERATURE = {
    "1": 20,
    "2": 68,
};

// ----------------------------------------------- //

//9-14
export const FROZEN_TEMPERATURE = {
    "1": 9,
    "2": 30,
};

//15-19
export const COLD_TEMPERATURE = {
    "1": 15,
    "2": 50,
};

//20-24
export const AGRI_SEASON_TEMPERATURE = {
    "1": 20,
    "2": 68,
};

//25-29
export const WARM_TEMPERATURE = {
    "1": 25,
    "2": 83,
};

//30-35
export const BOLLING_TEMPERATURE = {
    "1": 30,
    "2": 100,
};

export const MONTHS = {
    firstMonth: "January",
    lastMonth: "December",
};
